module.exports = __webpack_public_path__ + "static/crisis2-95eb6f43d6bb9f423e9d8f65b85fb690.jpg";